// src/pages/mantenimiento/componentes.jsx
import styles from './estilos';

export function Campo({ label, children }) {
  return <div style={{ marginBottom: '14px' }}><label style={styles.label}>{label}</label>{children}</div>;
}

export function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

export function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}

export function numeroSemanaActual() {
  const hoy = new Date();
  const inicio = new Date(hoy.getFullYear(), 0, 1);
  const dias = Math.floor((hoy - inicio) / (1000 * 60 * 60 * 24));
  return Math.ceil((dias + inicio.getDay() + 1) / 7);
}

export function primerDiaMesActual() {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-01`;
}